export const EXCHANGE = 'financial-metrics/exchange/EXCHANGE';
export const COMPANY = 'financial-metrics/company/COMPANY';
export const COMPANY_QUOTES = 'financial-metrics/company/COMPANY_QUOTES';
